import { apiClient } from '@/shared/api/client';
import type { ApiResponse } from '@/shared/types/api.types';
import type { RefereeVerificationInfo, UpdateRefereeInfoRequest } from '../types/referee-app.types';

export const refereeAppService = {
  async getRefereeVerificationInfo(shareId: string): Promise<RefereeVerificationInfo> {
    const response = await apiClient<ApiResponse<RefereeVerificationInfo>>(
      `/public/referees/${shareId}`,
      { method: 'GET' }
    );
    return response.data;
  },

  async updateRefereeInfo(
    shareId: string,
    data: UpdateRefereeInfoRequest
  ): Promise<RefereeVerificationInfo> {
    const response = await apiClient<ApiResponse<RefereeVerificationInfo>>(
      `/public/referees/${shareId}`,
      { method: 'PATCH', body: data }
    );
    return response.data;
  },

  async giveConsent(shareId: string): Promise<void> {
    await apiClient(`/public/referees/${shareId}/consent`, { method: 'PATCH' });
  },
};
